import { render, staticRenderFns } from "./documentTOPSERV.vue?vue&type=template&id=edfa8b08&scoped=true"
import script from "./documentTOPSERV.vue?vue&type=script&lang=js"
export * from "./documentTOPSERV.vue?vue&type=script&lang=js"
import style0 from "./documentTOPSERV.vue?vue&type=style&index=0&id=edfa8b08&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfa8b08",
  null
  
)

export default component.exports